import styled from 'styled-components';

const ThreadsLoading = styled.section``;

export default ThreadsLoading;
